import "./Pricing.scss";
import { Col, Image, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Pricing = (props) => {  
    const { t } = useTranslation(['common','pricing']);
    const contract = props?.contract;

    if(
        contract === undefined || contract === null ||
        contract?.contract_plan_details === undefined || contract?.contract_plan_details === null ||
        contract?.contract_plan_details?.length <= 0
    ){
        return (<></>)
    }
    
    return (
        <Row id="Pricing" className={props?.className}>
            {contract?.contract_plan_details.map((item, index) => {
                return (
                    <Col key={index} sm={12} md={12} lg={4}>
                        <Row>
                            <Col sm={12} className="header text-center">
                                <h3>{item.title}</h3>
                                <span className="price">€ {item.price}</span>
                                <span className="description">{item.description}</span>
                                <span className="purpose">{item?.purpose}</span>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col sm={12} className="feature">
                                {t("pricing:feature_1")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.included_incoming_items === null || item?.included_incoming_items  === "0" || item?.included_incoming_items  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt="TickImg"/>
                                    : item?.included_incoming_items}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_2")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.envelope_scanning_front === null || item?.envelope_scanning_front  === "0" || item?.envelope_scanning_front  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_2")})}/>
                                    : item?.envelope_scanning_front}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_3")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.item_content_scanning === null || item?.item_content_scanning  === "0" || item?.item_content_scanning  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_3")})}/>
                                    : item?.item_content_scanning}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_4")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.free_storage_days_letters === null || item?.free_storage_days_letters  === "0" || item?.free_storage_days_letters  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_4")})}/>
                                    : item?.free_storage_days_letters}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_5")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.free_storage_days_parcels === null || item?.free_storage_days_parcels  === "0" || item?.free_storage_days_parcels  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_5")})}/>
                                    : item?.free_storage_days_parcels}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_6")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.trashing_items === null || item?.trashing_items  === "0" || item?.trashing_items  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_6")})}/>
                                    : item?.trashing_items}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_7")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.dropbox_connection === null || item?.dropbox_connection  === "0" || item?.dropbox_connection  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_7")})}/>
                                    : item?.dropbox_connection}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_8")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.additional_incoming_items === null || item?.additional_incoming_items  === "0" || item?.additional_incoming_items  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_8")})}/>
                                    : '€' +item?.additional_incoming_items}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_9")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.envelope_scanning === null || item?.envelope_scanning  === "0" || item?.envelope_scanning  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_9")})}/>
                                    : '€' +item?.envelope_scanning}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_10")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.item_content_scanning === null || item?.item_content_scanning  === "0" || item?.item_content_scanning  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_10")})}/>
                                    : '€' +item?.item_content_scanning}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_11")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    €{" "}
                                    {item?.direct_forwarding_charge_per_incident === null || item?.direct_forwarding_charge_per_incident  === "0" || item?.direct_forwarding_charge_per_incident  === 0
                                    ? "0.00"
                                    : item?.direct_forwarding_charge_per_incident}
                                    {" "}
                                    {t("pricing:addShipping")}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_12")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    €{" "}
                                    {item?.collect_forwarding_charge_per_incident === null || item?.collect_forwarding_charge_per_incident  === "0" || item?.collect_forwarding_charge_per_incident  === 0
                                    ? "0.00"
                                    : item?.collect_forwarding_charge_per_incident}
                                    {" "}
                                    {t("pricing:addShipping")}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_13")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.storing_items_over_free_period_letters === null || item?.storing_items_over_free_period_letters  === "0" || item?.storing_items_over_free_period_letters  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_13")})}/>
                                    : '€' +item?.storing_items_over_free_period_letters}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_14")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.storing_items_over_free_period_packages === null || item?.storing_items_over_free_period_packages  === "0" || item?.storing_items_over_free_period_packages  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_14")})}/>
                                    : '€' +item?.storing_items_over_free_period_packages}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_15")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.scan_of_additional_pages === null || item?.scan_of_additional_pages  === "0" || item?.scan_of_additional_pages  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_15")})}/>
                                    : '€' +item?.scan_of_additional_pages}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} className="feature">
                                {t("pricing:feature_16")}
                            </Col>
                            <Col sm={12} className="value text-center">
                                <span>
                                    {item?.pages_included_in_content_scan === null || item?.pages_included_in_content_scan  === "0" || item?.pages_included_in_content_scan  === 0
                                    ? <Image src={"/images/feature-included.svg"} className="TickImg" alt={t('pricing:feature_included', {feature: t("pricing:feature_16")})}/>
                                    : item?.pages_included_in_content_scan}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <Link
                                    className="btn"
                                    text={t("pricing:order_now")}
                                    to={"/bestellen/geschaeftsadresse/"+item?.country_id + "/" + item.city_id + "/" +item?.id}
                                >{t("pricing:order_now")}</Link>
                            </Col>
                        </Row>
                    </Col>
                )
            })}
        </Row>
    )
}

export default Pricing;